import { render, staticRenderFns } from "./ShowRulerComponent.vue?vue&type=template&id=55805835&scoped=true"
import script from "./ShowRulerComponent.vue?vue&type=script&lang=js"
export * from "./ShowRulerComponent.vue?vue&type=script&lang=js"
import style0 from "./ShowRulerComponent.vue?vue&type=style&index=0&id=55805835&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55805835",
  null
  
)

export default component.exports